module.exports = __webpack_public_path__ + "static/img/026.b5f728a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-gejiachecun/026.png
// module id = 8xJB
// module chunks = 1